import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ correct3, correct2, correct1, unsure, incorrect, untouched, accepted }) => {
    // Calculate total. Ensure inputs are treated as numbers, defaulting to 0 if undefined/null.
    const c1 = Number(correct1) || 0;
    const c2 = Number(correct2) || 0;
    const c3 = Number(correct3) || 0;
    const u = Number(unsure) || 0;
    const i = Number(incorrect) || 0;
    const ut = Number(untouched) || 0;
    const a = Number(accepted) || 0;

    const total = c1 + c2 + c3 + u + i + ut + a;

    // Helper to calculate width, returns 0 if total is 0
    const calculateWidth = (value) => (total ? (value / total) * 100 : 0);

    // Threshold for displaying the number inside a segment (e.g., if segment width > 8%)
    const MIN_PERCENT_FOR_TEXT = 8;

    const segmentData = [
        { key: 'correct1', value: c1, className: 'progress-correct', labelText: 'Correct (1st attempt)' },
        { key: 'correct2', value: c2, className: 'progress-correct', labelText: 'Correct (2nd attempt)' },
        { key: 'correct3', value: c3, className: 'progress-correct', labelText: 'Correct (3rd+ attempt)' },
        { key: 'unsure', value: u, className: 'progress-unsure', labelText: 'Unsure' },
        { key: 'incorrect', value: i, className: 'progress-incorrect', labelText: 'Incorrect' },
        { key: 'untouched', value: ut, className: 'progress-untouched', labelText: 'Untouched' },
        { key: 'accepted', value: a, className: 'progress-accepted', labelText: 'Accepted' },
    ];

    // Calculate widths for each segment
    const processedSegments = segmentData.map(s => ({
        ...s,
        width: calculateWidth(s.value),
    }));

    return (
        <div className="progress-bar">
            {processedSegments.map(segment => (
                // Only render the segment if its value is greater than 0
                segment.value > 0 && (
                    <div
                        key={segment.key}
                        className={`progress-segment ${segment.className}`}
                        style={{ flex: `${segment.width}` }} // flex-grow based on percentage width
                        title={`${segment.labelText}: ${segment.value}`} // Tooltip always shows count
                    >
                        {/* Conditionally render the count inside the segment */}
                        {segment.width > MIN_PERCENT_FOR_TEXT && (
                            <span className="segment-count">{segment.value}</span>
                        )}
                    </div>
                )
            ))}
        </div>
    );
};

export default ProgressBar;
